import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Accordion } from "./components/setting-accordion";
import { Input } from "./components/input";
import { SaveButton } from "./components/save-button";
import SettingIcon from "../../../../../../images/settings-icons/setting-target.png";
import Icon from '@material-ui/core/Icon';
import Snackbar from "@material-ui/core/Snackbar";
import { modifyUser } from "../../../../../../api";

const LBS_PER_KG = 2.204622

const Row = styled.div`
  display: flex;
  @media (max-width: 1100px) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const UnitButton = styled.button`
  background: none;
  border: ${(props) => (props.selected ? "4px solid #07c43f" : "4px solid #ffffff00")};
  border-radius: 100px;
  color: #516375;
  font-size: 1rem;
  font-weight: 500;
  height: 56px;
  padding: 15px 15px;
  margin-left: 15px;
  text-transform: none;
  white-space: nowrap;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  @media (max-width: 900px) {
    font-size: .875rem;
    font-weight: 400;
    height: 38px;
    padding: 6px 16px;
    margin-top: 18px;
    margin-left: 8px;
  }
`;

const InputResizer = styled.div`
  align-self: flex-start;
  max-width: 200px;
  @media (max-width: 600px) {
    max-width: 140px;
  }
`;

const UpdateTargetWeight = (props) => {
  const [targetWeight, setTargetWeight] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [showSnack, setShowSnack] = useState(false);
  const [message, setMessage] = useState("");
  const [unitType, setUnitType] = useState(props.isUsingMetric ? 'kg' : 'lbs')
  const [show, setShow] = useState(false);

  useEffect(() => {
    if(props.targetWeight) {
      let newConvertedTargetWeight = props.isUsingMetric ? props.targetWeight.toFixed(1) : (props.targetWeight * LBS_PER_KG).toFixed(1);
      setTargetWeight(newConvertedTargetWeight);
    }
  }, []);

  useEffect(() => {
    if(props.targetWeight) {
      let newConvertedTargetWeight = props.isUsingMetric ? props.targetWeight.toFixed(1) : (props.targetWeight * LBS_PER_KG).toFixed(1);
      setTargetWeight(newConvertedTargetWeight);
    }
    setUnitType(props.isUsingMetric ? 'kg' : 'lbs')
  }, [props.targetWeight, props.isUsingMetric]);

  const validateTargetWeight = (targetWeightKg, weightKg, goal) => {
    const targetWeightKgRounded = Math.round(targetWeightKg * 100) / 100;
    const weightRounded = Math.round(weightKg * 100) / 100;

    if (goal === 'MUSCLE GAIN' && targetWeightKgRounded <= weightRounded) {
      setMessage("Choose a weight higher than your current weight");
      setShowSnack(true);
      return false;
    } else if (goal === 'FAT LOSS' && targetWeightKgRounded >= weightRounded) {
      setMessage("Choose a weight lower than your current weight");
      setShowSnack(true);
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    let targetWeightKg = targetWeight
    if (unitType === 'lbs') {
      targetWeightKg = targetWeight / LBS_PER_KG
    }

    if (validateTargetWeight(targetWeightKg, props.weight, props.goal)) {
      let mods = {};
      mods["target_weight"] = targetWeightKg;
  
      modifyUser(props.userId, props.portalId, mods)
        .then((res) => { 
          setTimeout(() => {
            setLoading(false);
            props.openSnackbar('Target weight updated', false);
            props.loadPortalAccount();
          }, 1000);
        }).catch((err) => {
          setTimeout(() => {
            setLoading(false);
            props.openSnackbar('Unable to update target weight', true)
          }, 1000);
        });

      // props
      //   .modifyUser(props.userId, mods)
      //   .then((res) => {
          // setLoading(false);
          // setMessage("Target weight updated");
          // setShowSnack(true);
      //     setShow(false);
      //     props.loadProfile(props.userId);
      //   })
      //   .catch((err) => {
          // setLoading(false);
          // setMessage("Unable to update target weight");
          // setShowSnack(true);
      //   });
    } else {
      return;
    }
  };
  
  let convertedTargetWeight;
  if (props.targetWeight) {
    convertedTargetWeight = props.isUsingMetric ? props.targetWeight.toFixed(1) : (props.targetWeight * LBS_PER_KG).toFixed(1);
  }
  const disabled = targetWeight === convertedTargetWeight || targetWeight === "";

  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}        
        icon={SettingIcon}
        settingName="Target weight"
        currentSetting={props.targetWeight ? `${convertedTargetWeight} ${props.isUsingMetric ? 'kg' : 'lbs'}` : 'None'}
        description="What is this user's target weight?"
        alternateColor
        // roundTop
      >
        <>
          <Row>
            <InputResizer>
              <Input onChange={(e) => setTargetWeight(e.target.value)} value={targetWeight} />
            </InputResizer>
            <div style={{display: 'flex'}}>
              <UnitButton selected={unitType === 'lbs'} onClick={() => setUnitType('lbs')}>
                Pounds
              </UnitButton>
              <UnitButton selected={unitType === 'kg'} onClick={() => setUnitType('kg')}>
                Kilograms
              </UnitButton>          
            </div>
          </Row>
          <ButtonRow>
            <SaveButton
              disabled={disabled}
              isLoading={isLoading}
              onClick={handleSubmit}
            />
          </ButtonRow>
        </>
      </Accordion>
      {/* <Snackbar
        className="snackbar"
        open={showSnack}
        message={message}
        autoHideDuration={3000}
        onClose={() => setShowSnack(false)}
      /> */}
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={showSnack}
        onClose={() => setShowSnack(false)}
        autoHideDuration={3000}
      >
        <div className="setting-snack">
          {message}
          <button onClick={() => setShowSnack(false)}>
            <Icon>close</Icon>
          </button>
        </div>
      </Snackbar>
    </>
  );
};

// function mapStateToProps(state) {
//   return {
//     isLoading: state.user.isLoading,
//     userId: state.user.id,
//     targetWeight: state.user.target_weight,
//     isUsingMetric: state.user.use_metric_units,
//     goal: state.user.goal,
//     weight: state.user.weight,
//   };
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ modifyUser, loadProfile }, dispatch);
// }

// export default connect(mapStateToProps, mapDispatchToProps)(UpdateTargetWeight);
export default UpdateTargetWeight;

